(function () {
  'use strict';

  function initExplodedView(sectionEl) {
    const section = sectionEl.querySelector('.ev-exploded-section');
    if (!section) return;

    const partComplete = section.querySelector('.ev-part-complete');
    const partR = section.querySelector('.ev-part-r');
    const partX = section.querySelector('.ev-part-x');
    const partG = section.querySelector('.ev-part-g');
    const partGG = section.querySelector('.ev-part-gg');
    const labelR = sectionEl.querySelector('.ev-label-for-r');
    const labelX = sectionEl.querySelector('.ev-label-for-x');
    const labelG = sectionEl.querySelector('.ev-label-for-g');
    const labelGG = sectionEl.querySelector('.ev-label-for-gg');
    const phaseNav = sectionEl.querySelector('.ev-phase-nav');
    const phaseDots = sectionEl.querySelectorAll('.ev-phase-dot');
    const msgTop = section.querySelector('.ev-message-top');
    const msgOverlay = section.querySelector('.ev-message-overlay');

    var scrollHint = sectionEl.querySelector('.ev-scroll-hint');
    var scrollHintAnim = section.querySelector('.ev-scroll-hint-anim');

    const partCombined = section.querySelector('.ev-part-combined');

    if (!partR || !partX || !partG || !partGG || !partComplete || !partCombined) return;

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    function setPhase(n) {
      phaseDots.forEach(function (d, i) {
        d.classList.toggle('active', i === n);
      });
    }

    // Position labels to follow their images
    // labelR = right side, labelG = left side, labelGG = right side
    function positionLabels(rY, xY, gY, ggY) {
      if (labelR) labelR.style.transform = 'translate(calc(100% + 20px), calc(-50% + ' + rY + 'px))';
      if (labelX) labelX.style.transform = 'translate(calc(-100% - 20px), calc(-50% + ' + xY + 'px))';
      if (labelG) labelG.style.transform = 'translate(calc(100% + 20px), calc(-50% + ' + gY + 'px))';
      if (labelGG) labelGG.style.transform = 'translate(calc(-100% - 20px), calc(-50% + ' + ggY + 'px))';
    }

    var spread = 260;

    function animate() {
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      var scrolled = -rect.top;
      var raw = clamp(scrolled / total, 0, 1);

      if (phaseNav) {
        phaseNav.classList.toggle('show', raw > 0.01 && raw < 0.98);
      }

      // Hide scroll hint once user starts scrolling into the animation
      if (scrollHint) {
        scrollHint.classList.toggle('hide', window.scrollY > 80);
      }

      // Show scroll hint inside animation at stable moments of each phase
      if (scrollHintAnim) {
        var showAnimHint = (raw > 0.01 && raw < 0.05) ||  // Just entered — product only
                           (raw > 0.08 && raw < 0.18) ||  // Phase 0 stable (assembled + text)
                           (raw > 0.42 && raw < 0.55) ||  // Phase 1 stable (exploded)
                           (raw > 0.68 && raw < 0.78) ||  // Phase 2 stable (highlight)
                           (raw > 0.88 && raw < 0.96);    // Phase 5 — combined image visible
        scrollHintAnim.classList.toggle('show', showAnimHint && raw < 0.95);
      }

      // PHASE 0 (0–0.25): Assembled — show complete image, hide parts
      if (raw < 0.25) {
        setPhase(0);
        var t = raw / 0.25;
        var float = Math.sin(t * Math.PI) * 5;

        partComplete.style.transform = 'translate(-50%, calc(-50% + ' + float + 'px))';
        partComplete.style.opacity = 1;

        partR.style.opacity = 0;
        partX.style.opacity = 0;
        partG.style.opacity = 0;
        partGG.style.opacity = 0;
        partCombined.style.opacity = 0;
        partR.classList.remove('highlight');
        partX.classList.remove('highlight');
        partG.classList.remove('highlight');

        labelR.classList.remove('show');
        labelX.classList.remove('show');
        labelG.classList.remove('show');
        labelGG.classList.remove('show');
        positionLabels(0, 0, 0, 0);

        msgTop.classList.toggle('show', t > 0.3);
        msgTop.style.transform = 'translateX(-50%)';
        msgTop.querySelector('span').textContent = msgTop.dataset.phase0;
        msgOverlay.classList.toggle('show', t > 0.3);
        msgOverlay.querySelector('h2').innerHTML = msgOverlay.dataset.phase0Title;
        msgOverlay.querySelector('p').textContent = msgOverlay.dataset.phase0Sub;
      }

      // PHASE 1 (0.25–0.6): Explode — fade out complete, separate parts, labels follow
      else if (raw < 0.6) {
        setPhase(1);
        var t1 = easeOut((raw - 0.25) / 0.35);

        var fadeOut = clamp(1 - t1 * 4, 0, 1);
        partComplete.style.opacity = fadeOut;
        partComplete.style.transform = 'translate(-50%, -50%)';

        var fadeIn = clamp(t1 * 3, 0, 1);
        var rY = -t1 * spread * 0.95;
        var xY = -t1 * spread * 0.38;
        var gY = t1 * spread * 0.20;
        var ggY = t1 * spread;

        partR.style.opacity = fadeIn;
        partX.style.opacity = fadeIn;
        partG.style.opacity = fadeIn;
        partGG.style.opacity = fadeIn;
        partR.style.transform = 'translate(-50%, calc(-50% + ' + rY + 'px))';
        partX.style.transform = 'translate(-50%, calc(-50% + ' + xY + 'px))';
        partG.style.transform = 'translate(-50%, calc(-50% + ' + gY + 'px))';
        partGG.style.transform = 'translate(-50%, calc(-50% + ' + ggY + 'px))';
        partCombined.style.opacity = 0;
        partR.classList.remove('highlight');
        partX.classList.remove('highlight');
        partG.classList.remove('highlight');

        // Labels follow images
        positionLabels(rY, xY, gY, ggY);
        var labelT = clamp((t1 - 0.4) / 0.4, 0, 1);
        labelR.classList.toggle('show', labelT > 0.3);
        labelX.classList.toggle('show', labelT > 0.45);
        labelG.classList.toggle('show', labelT > 0.6);
        labelGG.classList.toggle('show', labelT > 0.75);

        // Message top follows explosion upward, stays above partR
        msgTop.classList.add('show');
        msgTop.style.transform = 'translateX(-50%) translateY(' + (rY * 0.6) + 'px)';
        msgTop.querySelector('span').textContent = msgTop.dataset.phase1;
        msgOverlay.classList.remove('show');
      }

      // PHASE 2 (0.6–1.0): Base disappears, R+G highlight then merge into combined image
      else {
        setPhase(2);
        var t2 = (raw - 0.6) / 0.4; // linear 0–1

        partComplete.style.opacity = 0;

        // Sub-phase A (t2 0–0.45): base disappears, R+G highlight
        // Sub-phase B (t2 0.45–1): R+G converge to center and fade, combined fades in
        var baseGone = clamp(t2 / 0.3, 0, 1); // base fully gone by t2=0.3
        var ggY2 = spread + baseGone * 60; // slide down as it fades
        partGG.style.transform = 'translate(-50%, calc(-50% + ' + ggY2 + 'px))';
        partGG.style.opacity = 1 - baseGone;

        // Positions at end of phase 1
        var rYstart = -spread * 0.95;
        var xYstart = -spread * 0.38;
        var gYstart = spread * 0.20;

        if (t2 < 0.45) {
          // Sub-phase A: highlight, keep exploded positions
          var tA = easeOut(t2 / 0.45);
          var rY2 = rYstart - tA * 20;
          var xY2 = xYstart - tA * 12;
          var gY2 = gYstart;

          partR.style.transform = 'translate(-50%, calc(-50% + ' + rY2 + 'px))';
          partR.style.opacity = 1;
          partR.classList.toggle('highlight', tA > 0.2);

          partX.style.transform = 'translate(-50%, calc(-50% + ' + xY2 + 'px))';
          partX.style.opacity = 1;
          partX.classList.toggle('highlight', tA > 0.2);

          partG.style.transform = 'translate(-50%, calc(-50% + ' + gY2 + 'px))';
          partG.style.opacity = 1;
          partG.classList.toggle('highlight', tA > 0.2);

          partCombined.style.opacity = 0;

          positionLabels(rY2, xY2, gY2, ggY2);
          labelR.classList.add('show');
          labelX.classList.add('show');
          labelG.classList.add('show');
          labelGG.classList.toggle('show', t2 < 0.15);

          msgTop.classList.remove('show');
          msgTop.style.transform = 'translateX(-50%)';
          msgOverlay.classList.toggle('show', tA > 0.5);
          msgOverlay.querySelector('h2').innerHTML = msgOverlay.dataset.phase2Title;
          msgOverlay.querySelector('p').textContent = msgOverlay.dataset.phase2Sub;
        } else {
          // Sub-phase B: R+G converge to center, fade out; combined fades in
          var tBraw = (t2 - 0.45) / 0.55; // linear 0–1
          // Smooth ease-in-out for natural feel
          var tB = tBraw * tBraw * (3 - 2 * tBraw);

          // R moves down toward center, G moves up toward center
          var rY2 = (rYstart - 20) * (1 - tB);
          var xY2 = (xYstart - 12) * (1 - tB);
          var gY2 = gYstart * (1 - tB);

          // Synchronized crossfade: parts fade out as combined fades in
          var partsFade = clamp(1 - tB * 1.2, 0, 1);
          var combinedFade = clamp((tB - 0.15) / 0.7, 0, 1);

          partR.style.transform = 'translate(-50%, calc(-50% + ' + rY2 + 'px))';
          partR.style.opacity = partsFade;
          partR.classList.add('highlight');

          partX.style.transform = 'translate(-50%, calc(-50% + ' + xY2 + 'px))';
          partX.style.opacity = partsFade;
          partX.classList.add('highlight');

          partG.style.transform = 'translate(-50%, calc(-50% + ' + gY2 + 'px))';
          partG.style.opacity = partsFade;
          partG.classList.add('highlight');

          // Combined: scale up from 0.92 to 1 for a satisfying "snap together"
          var combinedScale = 0.92 + combinedFade * 0.08;
          partCombined.style.opacity = combinedFade;
          partCombined.style.transform = 'translate(-50%, -50%) scale(' + combinedScale + ')';

          positionLabels(rYstart - 20, xYstart - 12, gYstart, ggY2);
          labelR.classList.add('show');
          labelX.classList.add('show');
          labelG.classList.add('show');
          labelGG.classList.remove('show');

          msgTop.classList.remove('show');
          msgTop.style.transform = 'translateX(-50%)';
          msgOverlay.classList.add('show');
          msgOverlay.querySelector('h2').innerHTML = msgOverlay.dataset.phase2Title;
          msgOverlay.querySelector('p').textContent = msgOverlay.dataset.phase2Sub;
        }
      }
    }

    // Click on phase dots to scroll to that phase
    var phaseTargets = [0.1, 0.42, 0.72]; // raw values for center of each phase
    phaseDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var sectionTop = section.getBoundingClientRect().top + window.scrollY;
        var total = section.offsetHeight - window.innerHeight;
        var targetScroll = sectionTop + phaseTargets[i] * total;
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      });
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          animate();
          ticking = false;
        });
        ticking = true;
      }
    });

    animate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ev-wrapper').forEach(initExplodedView);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var wrapper = e.target.querySelector('.ev-wrapper');
      if (wrapper) initExplodedView(wrapper);
    });
  }
})();

